:host {
  display: inline-block;
  width: auto;
  height: auto;
}

.filter {
  &--content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: var(--single-select-list-content-max-height);
    overflow: hidden;
  }
}

:host([disabled]) {
  pointer-events: none;
  opacity: 0.6;
}

:host([isLoading]) {
  .dropdown-list {
    &--inner {
      overflow: hidden;
    }
  }
}

.dropdown-error {
  display: flex;
  padding: var(--spacer);
  color: var(--red-layout-300-primary);
  overflow: auto;
  line-height: var(--body-size);
}

$labelWidths: 80, 160, 240;
$labelWidthFull: 100%;
$labelWidthAuto: auto;

@each $size in $labelWidths {
  :host([labelWidth='#{$size}']) {
    .error-message {
      width: #{$size}px;
    }
  }
}

:host([labelWidth='full']) {
  .error-message {
    width: $labelWidthFull;
  }
}

:host([labelWidth='auto']) {
  .error-message {
    width: $labelWidthAuto;
  }
}

:host([isError]) {
  pointer-events: none;
}

.single-select-list {
  width: var(--dropdown-list-width, 240px);
}
